// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] + "." + {"265":"b2a44d2d","297":"6f5eb786","643":"495bc710"}[chunkId] + ".chunk.js";
};